import React from 'react';
import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';

interface Stage {
  done: boolean;
  label: string;
  step: string;
}

interface Props {
  saleOrLease: string;
  stages: Stage[];
}

export default function GatesProgressStepper({ saleOrLease, stages }: Props) {
  const current = stages.map(stage => stage.done).lastIndexOf(true);

  return (
    <ol
      aria-label={`${saleOrLease} progress`}
      className="d-flex flex-wrap list-unstyled mb-0 border rounded overflow-hidden"
    >
      {stages.map((stage, index) => (
        <li
          aria-current={index === current ? 'step' : undefined}
          className={classNames(
            'd-flex align-items-center justify-content-center gap-2 p-2 border-start border-top text-center fs-small',
            { 'bg-success bg-opacity-10': stage.done }
          )}
          key={stage.step}
          style={{ flex: '1 0 0', margin: '-1px 0 0 -1px' }}
        >
          <FontAwesomeIcon className={stage.done ? 'text-success' : 'text-muted'} icon={faCircleCheck} />
          <span className={stage.done ? 'fw-semibold' : 'text-muted'}>
            {stage.label}
            {stage.done && <span className="visually-hidden"> complete</span>}
          </span>
        </li>
      ))}
    </ol>
  );
}
